var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.isKit
    ? _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c(
            "b-badge",
            { staticClass: "mr-50", attrs: { variant: "primary" } },
            [_vm._v(" " + _vm._s(_vm.$t("Kit")) + " ")]
          ),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.item.name)),
          ]),
        ],
        1
      )
    : _vm.item.isKitItem
    ? _c(
        "div",
        { staticClass: "d-flex align-items-center kit-item-name" },
        [
          _c("b-icon", {
            staticClass: "mr-50",
            attrs: { icon: "arrow-return-right" },
          }),
          _c("span", [_vm._v(_vm._s(_vm.item.name))]),
        ],
        1
      )
    : _c("span", [_vm._v(_vm._s(_vm.item.name))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }